import { X } from "lucide-react";
import { Button } from "~/atoms/button";

interface RemovableIndicatorChipProps {
  label?: string;
  comparatorLabel?: string;
  value: string;
  onRemove: () => void;
}

export const RemovableIndicatorChip = ({
  label,
  comparatorLabel,
  value,
  onRemove,
}: RemovableIndicatorChipProps) => (
  <div className="border-border flex gap-1 rounded-md border px-1 text-sm font-normal">
    {label && <span className="p-1">{label}</span>}
    {comparatorLabel && (
      <span className="text-secondary-foreground bg-secondary px-2 py-1">
        {comparatorLabel}
      </span>
    )}
    <span className="p-1">{value}</span>
    <Button variant="ghost" size="icon-sm" onClick={onRemove}>
      <X />
    </Button>
  </div>
);
